import { Controller } from 'stimulus'

// Calculated task measurements (formulas over the results grid) on a task's
// Results tab. The server recomputes them whenever results change; this
// fetches their value and status cells again, debounced, on the same signals
// the Results Summary follows: a remote form or link inside the tab succeeds
// (cell saves, row actions), a response says so (task-results:changed), or a
// broadcast reloads the grid (resourceable:reloaded).
const SETTLE_MS = 800

export default class extends Controller {
  connect() {
    this.onAjax = this.onAjax.bind(this)
    this.schedule = this.schedule.bind(this)
    document.addEventListener('ajax:success', this.onAjax)
    document.addEventListener('task-results:changed', this.schedule)
    document.addEventListener('resourceable:reloaded', this.schedule)
  }

  disconnect() {
    document.removeEventListener('ajax:success', this.onAjax)
    document.removeEventListener('task-results:changed', this.schedule)
    document.removeEventListener('resourceable:reloaded', this.schedule)
    clearTimeout(this.timer)
  }

  onAjax(event) {
    if (!this.element.contains(event.target)) { return }
    this.schedule()
  }

  schedule() {
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.load(), SETTLE_MS)
  }

  load() {
    fetch(this.data.get('url'), {
      credentials: 'same-origin',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(response => (response.ok ? response.json() : Promise.reject(response)))
      .then(({ cells }) => {
        cells.forEach(({ id, value, status }) => {
          this.replace(`task_field_value_${id}`, value)
          this.replace(`task_field_status_${id}`, status)
        })
      })
      .catch(() => {})
  }

  replace(elementId, html) {
    const current = document.getElementById(elementId)
    if (current) { current.outerHTML = html }
  }
}
